import React from 'react';
import { Info, HelpCircle } from 'lucide-react';
import './AdminContextCard.css';

const AdminContextCard = () => {
  return (
    <div className="ad-card ad-context-card">
      <div className="ad-context-header">
        <div className="ad-kpi-icon context-icon">
          <Info size={24} />
        </div>
        <div>
          <h3>Guía de Inteligencia Operativa</h3>
          <p>Entendiendo las métricas de Non Stop Learning</p>
        </div>
      </div>
      
      <div className="ad-context-grid">
        <div className="ad-context-item">
          <h4>💰 Control Financiero (Global)</h4>
          <p>
            Los indicadores superiores muestran el <strong>gasto total de infraestructura IA</strong>. 
            La "Proyección Mensual" estima tu factura final basada en el consumo actual. 
            Útil para detectar fugas de presupuesto.
          </p>
        </div>

        <div className="ad-context-item">
          <h4>🎓 Pulso Educativo (Engagement)</h4>
          <p>
            La gráfica de líneas mide el esfuerzo real de los alumnos. 
            Un pico en <strong>Palabras Habladas</strong> es el mejor indicador de éxito pedagógico.
          </p>
        </div>

        <div className="ad-context-item">
          <h4>🧠 Eficiencia Técnica (Tokens)</h4>
          <p>
            <strong>Input:</strong> Lo que enviamos a la IA. 
            <strong>Output:</strong> Lo que la IA responde (suele ser más caro). 
            Controlar esta proporción ayuda a optimizar los Prompts del sistema.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminContextCard;